import * as generalActions from 'store/general/actions';
import * as companyActions from 'store/company/actions';
import * as naActions from 'store/na/actions';
import * as warningActions from 'store/warning/actions';
import * as userActions from 'store/user/actions';
import * as externalAccessActions from 'store/externalAccess/actions';

const actions = {
  general: generalActions,
  company: companyActions,
  na: naActions,
  warning: warningActions,
  user: userActions,
  externalAccess: externalAccessActions,
};

export default actions;
